export function focusNextError(): void {
	const errorEl = document.getElementsByClassName("focusable-error")[0] as HTMLElement;
	if (errorEl) {
		errorEl.focus();
	}
}